import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import LabelContactBulkOperationsAPI from '../../api/labelContactBulkOperations';

export const state = {
  records: [],
  preview: null,
  uiFlags: {
    isFetching: false,
    isPreviewing: false,
    isCreating: false,
  },
};

export const getters = {
  getOperations: $state => $state.records,
  getPreview: $state => $state.preview,
  getUIFlags: $state => $state.uiFlags,
};

const cableRecordFrom = payload => ({
  id: payload.operation_id,
  label_id: payload.label_id,
  label_title: payload.label_title,
  action: payload.action,
  status: payload.status,
  total_contacts: payload.total_contacts,
  processed_contacts: payload.processed_contacts,
  updated_contacts: payload.updated_contacts,
  skipped_contacts: payload.skipped_contacts,
  failed_contacts: payload.failed_contacts,
  completed_at: payload.completed_at,
  error_message: payload.error_message,
});

export const actions = {
  fetch: async ({ commit }, params = {}) => {
    commit(types.SET_LCBO_UI_FLAG, { isFetching: true });
    try {
      const { data } = await LabelContactBulkOperationsAPI.list(params);
      commit(types.SET_LCBO_RECORDS, data.payload);
    } finally {
      commit(types.SET_LCBO_UI_FLAG, { isFetching: false });
    }
  },

  preview: async ({ commit }, { labelId, action }) => {
    commit(types.SET_LCBO_UI_FLAG, { isPreviewing: true });
    commit(types.SET_LCBO_PREVIEW, null);
    try {
      const { data } = await LabelContactBulkOperationsAPI.preview({
        labelId,
        action,
      });
      commit(types.SET_LCBO_PREVIEW, data.payload);
      return data.payload;
    } finally {
      commit(types.SET_LCBO_UI_FLAG, { isPreviewing: false });
    }
  },

  create: async ({ commit }, { labelId, action }) => {
    commit(types.SET_LCBO_UI_FLAG, { isCreating: true });
    try {
      const { data } = await LabelContactBulkOperationsAPI.create({
        labelId,
        action,
      });
      commit(types.PREPEND_LCBO_RECORD, data.payload);
      return data.payload;
    } finally {
      commit(types.SET_LCBO_UI_FLAG, { isCreating: false });
    }
  },

  updateFromCable: ({ commit, state: $state }, payload) => {
    const record = cableRecordFrom(payload);
    const exists = $state.records.some(r => r.id === record.id);
    if (exists) {
      commit(types.UPDATE_LCBO_RECORD, record);
    } else {
      commit(types.PREPEND_LCBO_RECORD, record);
    }
  },
};

export const mutations = {
  [types.SET_LCBO_UI_FLAG]($state, flags) {
    $state.uiFlags = { ...$state.uiFlags, ...flags };
  },
  [types.SET_LCBO_RECORDS]($state, records) {
    $state.records = records;
  },
  [types.SET_LCBO_PREVIEW]($state, preview) {
    $state.preview = preview;
  },
  [types.PREPEND_LCBO_RECORD]($state, record) {
    $state.records = [
      record,
      ...$state.records.filter(r => r.id !== record.id),
    ];
  },
  [types.UPDATE_LCBO_RECORD]($state, record) {
    MutationHelpers.update($state, record);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
